import React from 'react';
import { GitBranch, Globe, Shield, Terminal, Github, Gitlab, Container, Archive } from 'lucide-react';
import SectionHeader from './SectionHeader';

const features = [
  {
    icon: <GitBranch size={22} />,
    title: 'One-click deployments',
    desc: 'Connect GitHub or GitLab, pull from Docker Hub, or upload a ZIP — ship without fighting infrastructure.',
    visual: 'integrations',
  },
  {
    icon: <Globe size={22} />,
    title: 'Automated routing & SSL',
    desc: 'Dynamic ports, Nginx reverse proxies, and certificates are provisioned automatically for every app.',
    visual: 'routing',
  },
  {
    icon: <Terminal size={22} />,
    title: 'Live logs & terminal',
    desc: 'Stream build output instantly and open an in-browser shell when you need to debug production.',
    visual: 'monitor',
  },
  {
    icon: <Shield size={22} />,
    title: 'Built for teams',
    desc: 'Role-based access, siloed workspaces, and owner controls keep agency and client projects isolated.',
    visual: 'team',
  },
];

const FeatureVisual = ({ type }) => {
  if (type === 'integrations') {
    return (
      <div className="lp-feature-visual lp-feature-integrations">
        <span><Github size={16} /> GitHub</span>
        <span><Gitlab size={16} /> GitLab</span>
        <span><Container size={16} /> Docker</span>
        <span><Archive size={16} /> ZIP</span>
      </div>
    );
  }
  if (type === 'routing') {
    return (
      <div className="lp-feature-visual lp-feature-routing">
        <div className="bar"><span /> app.devorants.io</div>
        <div className="bar thin"><span /> SSL active</div>
        <div className="bar thin"><span /> Port 3342</div>
      </div>
    );
  }
  if (type === 'monitor') {
    return (
      <div className="lp-feature-visual lp-feature-monitor">
        <div className="pulse" />
        <div className="bars">
          <i /><i /><i /><i /><i /><i />
        </div>
      </div>
    );
  }
  return (
    <div className="lp-feature-visual lp-feature-team">
      <span className="dot a">A</span>
      <span className="dot b">D</span>
      <span className="dot c">O</span>
      <em>RBAC enabled</em>
    </div>
  );
};

const FeaturesSection = () => (
  <div className="lp-section lp-features">
    <div className="lp-container">
      <SectionHeader
        badge="Features"
        title="Everything you need to ship faster"
        subtitle="We abstract away the infrastructure so you can focus on building."
      />
      <div className="lp-feature-grid">
        {features.map((feature) => (
          <article key={feature.title} className="lp-feature-card">
            <div className="lp-feature-icon">{feature.icon}</div>
            <h3>{feature.title}</h3>
            <p>{feature.desc}</p>
            <FeatureVisual type={feature.visual} />
          </article>
        ))}
      </div>
    </div>
  </div>
);

export default FeaturesSection;
